import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Students from './components/Students';
import Buses from './components/Buses';
import Settings from './components/Settings';
import ApprovalRequests from './components/ApprovalRequests';
import AttendanceLog from './components/AttendanceLog';
import AttendanceReports from './components/AttendanceReports';
import SOSAlerts from './components/SOSAlerts';
import StudentMeter from './components/StudentMeter';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/students" element={<Students />} />
        <Route path="/buses" element={<Buses />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/approval-requests" element={<ApprovalRequests />} />
        <Route path="/attendance-log" element={<AttendanceLog />} />
        <Route path="/attendance-reports" element={<AttendanceReports />} />
        <Route path="/sos-alerts" element={<SOSAlerts />} />
        <Route path="/student-meter" element={<StudentMeter />} />
      </Routes>
    </Router>
  );
}

export default App;